import * as React from 'react';
import { PersonaSize, TooltipDelay, TooltipHost } from 'office-ui-fabric-react';
import { Resource, ResourceStatus } from '../../../store/ResourcesListStore';
import { ImagePersonaCoin } from '../../common/ImagePersona';
import { ResourceName } from '../../views/list/columns/resource/Name';
import { StatusView } from '../../views/list/columns/resource/Status';

type OwnProps = {
    resource: Resource;
};

export const AssignmentsResourceName = (props: OwnProps) => {
    const { resource } = props;
    const isInactive = resource.attributes.Status === ResourceStatus.Inactive;
    const canView = resource.isEditable || resource.canView;

    return <TooltipHost
        tooltipProps={{
            onRenderContent: () => <StateTooltipContent resource={resource} isInactive={isInactive} />,
            maxWidth: '464px',
            styles: { root: { width: '100%' } }
        }}
        closeDelay={10}
        delay={TooltipDelay.long}>
        <ResourceName name={resource.name} imageId={resource.imageId} href={`/resource/${resource.id}`} warnings={resource.warnings}
            canView={canView} isInactive={isInactive} />
    </TooltipHost>;
}

const StateTooltipContent = (props: { resource: Resource, isInactive: boolean }) => {
    const { resource, isInactive } = props;
    const status = resource.attributes.Status;
    return <div className="timeline-tooltip">
        <div className="header">
            <span className={isInactive ? 'inactive-persona' : undefined}>
                <ImagePersonaCoin className="logo" size={PersonaSize.size32} info={resource} text={resource.name} />
                {isInactive && <span className="inactive-icon" />}
            </span>
            <div className="title">
                <div className="overflow-text" title={resource.name}>{resource.name}</div>
            </div>
        </div>
        <div className="content">
            {status !== undefined && <div className="item align-center">
                <div className="label">State</div>
                <StatusView status={status} />
            </div>}
        </div>
    </div>;
}
